import { msalInstance } from '../../App';
import { InteractionRequiredAuthError } from "@azure/msal-browser";

export class IssuesDetailsService {

    async invokeWebAPI(url, httpMethod, msalContext, body = "") {
        try {
            if (msalContext.accounts.length > 0) {
                const tokenRequest = {
                    scopes: [global.ENV_MSAL_LOGIN_REQUEST_SCOPES],
                    account: msalContext.accounts[0],
                };

                try {
                    // acquire Bearer token to include in GET request
                    const tokenResponse = await msalInstance.acquireTokenSilent(tokenRequest);
                    const token = tokenResponse.accessToken;
                    const bearer = `Bearer ${token}`;
                    const headers = new Headers();
                    headers.append('Accept', '*/*');
                    headers.append('Content-Type', 'application/json');
                    headers.append('x-northwell-version', '1.0');
                    headers.append("Authorization", bearer);
                    headers.append('User', msalContext.accounts[0].username)

                    var options = {}
                    if (body) {
                        options = {
                            method: httpMethod,
                            headers: headers,
                            body: body
                        };
                    } else {
                        options = {
                            method: httpMethod,
                            headers: headers
                        };
                    }

                    let response = await fetch(url, options);

                    return {
                        status: response.status,
                        body: await response.json()
                    };
                } catch (error) {
                    if (error instanceof InteractionRequiredAuthError) {
                        // Show popup to user
                        if (window.alertMessage && window.alertMessage.current) {
                            window.alertMessage.current.show({
                                severity: 'warn',
                                summary: 'Authentication Required',
                                detail: 'Your session has expired or additional authentication is required. Please login again.',
                                life: 5000
                            });
                        } else {
                            alert('Session Expired !!! Authentication Required: Please login again.');
                        }
                        // Optionally, trigger a redirect or popup login
                        msalInstance.loginRedirect(tokenRequest);
                    } else {
                        console.log(error);
                    }
                }
            } else {
                console.log('user not logged in')
            }
        } catch (e) {
            console.log(e);
        }
    }

    async getIssueDetailsTableData(fromDate, toDate, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/Notification/ByDateRange?FromDate=" + fromDate + "&ToDate=" + toDate + "&alertTypes=2";
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }


    async getIssueDetailsById(id, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/Notification/" + id;
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async updateNotificationStatus(id, body, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/Notification/" + id + "/Status";
        try {
            const response = await this.invokeWebAPI(url, 'PUT', msalContext, body);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    //HM-837 - Allow multi select of alerts for closure
    async updateMultipleNotificationStatus(body, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/Notification/Multiple/Status";
        try {
            const response = await this.invokeWebAPI(url, 'PUT', msalContext, body);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getStatusHistory(id, msalContext) {

        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/Notification/" + id + "/Status/History";
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }

    async getIssueCount(msalContext) {
        const url = global.ENV_HIE_ADMIN_API_AZURE_URL + "/Notification/Dashboard/Count";
        try {
            const response = await this.invokeWebAPI(url, 'GET', msalContext);
            return response;
        } catch (e) {
            console.log(e);
        }
    }
}